import styled from 'styled-components';

export const Container = styled.div`
  padding-left: 60px;
  .main-header {
    background: #fff;
  }

  & .title {
    margin-left: 10px;
  }

  .mh-logo {
    display: inherit;
    padding-right: 20px;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  .container {
    width: 100%;
    max-width: 100%;
    padding: 10px 30px;
    margin: 0 auto;
  }
  .customised_331 {
    width: 100px;
    padding: 8px 0 0 0;
    Icon {
      width: 100%;
    }
  }

  .main-header .container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  .main-nav {
    flex-grow: 1;
  }

  .main-nav-list {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-wrap: wrap;

    div {
      display: inline-flex;
      padding: 0.25rem;
    }
  }
`;
